import { createContext, type PropsWithChildren } from 'react';
import type { OnboardingChecklistStep } from '../shared/types';

// No runtime imports from the step definitions — they use the page context's hooks, and
// `page-context` mounts this provider, so importing them here would close a module cycle.
// The `DEFAULT_SETUP_STEPS` fallback lives in `useSetupSteps` instead.
export const SetupStepsContext = createContext<OnboardingChecklistStep[] | null>(null);
SetupStepsContext.displayName = 'SetupStepsContext';

/**
 * Single source of truth for the platform's setup steps, so the setup page and the pre-launch
 * banners can't disagree. Mounted by `withPageProviders` from its `setupSteps` input.
 */
export function SetupStepsProvider({
  steps,
  children,
}: PropsWithChildren<{ steps: OnboardingChecklistStep[] | undefined }>) {
  return <SetupStepsContext.Provider value={steps ?? null}>{children}</SetupStepsContext.Provider>;
}
